<template>
    <div>
        <v-text-field
            :label="label"
            @click="onPickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            :error-messages="errorMessage"
            clearable
            :hint="hint"
            :rules="rules"
        ></v-text-field>
        <input type="file" class="d-none" ref="fileInput" :accept="accept" :multiple="multiple" @change="onFilePicked" />
    </div>
</template>

<script>
export default {
    name: 'FileInput',
    props: {
        value: {
            type: [Array, File, FileList],
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        fileSizeLimit: {
            type: Number,
            default: 0,
        },
        hint: {
            type: String,
            default: '',
        },
        accept: {
            type: String,
            default: '',
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        fileName: '',
        url: '',
        fileObject: null,
        error: false,
    }),
    methods: {
        onPickFile() {
            this.$refs.fileInput.click();
        },
        onFilePicked(event) {
            const files = event.target.files;
            if (files[0] !== undefined) {
                //TODO: move validation
                if (!this.validFileSize(files)) {
                    this.error = true;
                    return false;
                }
                this.error = false;
                this.fileName = (this.multiple && Array.from(files).length > 1)
                    ? Array.from(files).reduce(
                        (accumulator, file) =>
                            (typeof accumulator === 'string' ? accumulator : accumulator.name) + ', ' + file.name,
                    )
                    : files[0].name;
                // Check validity of file
                if (this.fileName.lastIndexOf('.') <= 0) {
                    return;
                }
                // If valid, continue
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener('load', () => {
                    this.url = fr.result;
                    this.fileObject = this.multiple ? files : files[0];
                    this.$emit('input', this.fileObject);
                });
            } else {
                this.fileName = '';
                this.fileObject = null;
                this.url = '';
                this.$emit('input', this.fileObject);
            }
        },
        validFileSize(files) {
            if (this.fileSizeLimit === 0) {
                return true;
            }

            return !Array.from(files).filter(file => file.size / 1024 > this.fileSizeLimit).length;
        },
    },
    computed: {
        errorMessage() {
            return this.error ? [this.$language.translate('File limit is 10 MB')] : [];
        },
    },
};
</script>

<style scoped></style>
